'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fat';
var iconName = 'book-open-cover';
var width = 640;
var height = 512;
var aliases = ["book-open-alt"];
var unicode = 'e0c0';
var svgPathData = 'M329.4 433l217.7-43.5c7.5-1.5 12.9-8.1 12.9-15.7l0-340.3c0-9.7-8.6-17.2-18.2-15.9L328 47.1l0 386.2c.5-.1 .9-.2 1.4-.3zm-17.4 .3l0-386.2L98.2 17.7C88.6 16.3 80 23.8 80 33.5l0 340.3c0 7.6 5.4 14.2 12.9 15.7L310.6 433c.5 .1 .9 .2 1.4 .3zM539.6 1.8C558.9-.8 576 14.1 576 33.5l0 340.3c0 15.3-10.8 28.4-25.7 31.4L332.6 448.7c-8.3 1.7-16.8 1.7-25.1 0L89.7 405.1c-15-3-25.7-16.1-25.7-31.4L64 33.5C64 14.1 81.1-.8 100.4 1.8L320 32 539.6 1.8zM0 65.5c0-17.9 14.6-32 32-32l0 16c-8.7 0-16 7-16 16l0 353.1c0 7.6 5.4 14.2 12.9 15.7l281.7 56.3c6.2 1.2 12.6 1.2 18.8 0l281.7-56.3c7.5-1.5 12.9-8.1 12.9-15.7l0-353.1c0-9-7.3-16-16-16l0-16c17.4 0 32 14.1 32 32l0 353.1c0 15.3-10.8 28.4-25.7 31.4L332.6 506.3c-8.3 1.7-16.8 1.7-25.1 0L25.7 449.9C10.8 447 0 433.8 0 418.6L0 65.5z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBookOpenCover = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;